import { render, staticRenderFns } from "./mGaugeDefaultSettings.vue?vue&type=template&id=2bf9ab25&scoped=true&"
import script from "./mGaugeDefaultSettings.vue?vue&type=script&lang=js&"
export * from "./mGaugeDefaultSettings.vue?vue&type=script&lang=js&"
import style0 from "./mGaugeDefaultSettings.vue?vue&type=style&index=0&id=2bf9ab25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf9ab25",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/mGaugeDefaultSettings.vue
// module id = null
// module chunks = 